<template>
  <div id="Xvapp">
    <Header v-if="admin_type() == 'admin'"></Header>
    <Header_G v-if="admin_type() == 'admin-g'"></Header_G>
    <transition mode="out-in">
      <keep-alive>
        <router-view />
      </keep-alive>
    </transition>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../header/header.vue";
import Header_G from "../header-g/header.vue";
import Footer from "../footer/footer.vue";
export default {
  name: "Xvapp",
  components: {
    Header,
    Footer,
    Header_G
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    admin_type() {
      var path = this.$route.path;
      var admin = path.includes("xv-admin/");
      if (admin == true) {
        return "admin";
      } else {
        return "admin-g";
      }
    }
  }
};
</script>
